<template>
	<v-flex xs12 v-if="documents && Object.keys(documents).length">
		<v-flex xs12>
			<confirmation-header-text
					icon="mdi-attachment"
					:text="headerText"
			/>
		</v-flex>
		<v-flex xs12 class="mt-2">
			<v-layout class="" row v-for="(d,index) in documents" wrap :key="index">
				<v-flex xs12>
					<v-alert type="info"
					         outlined
					         :icon="false"
					         dense
					         class="mb-2">
						<span style="color: #1566C0;">{{ index }}: {{ d.name }}</span>
					</v-alert>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-flex>

</template>

<script>
import ConfirmationHeaderText from "./ConfirmationHeaderText";

export default {
	name: "IdentityDocuments",
	props: ['documents', 'headerText'],
	components: {
		ConfirmationHeaderText
	}
}
</script>

